import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconTools from '@/icons/Tools.svg';

import { useFilters } from '../FiltersState';
import { useSubLocationOptions } from '../utils';

export const FiltersSubLocation = () => {
  const { t } = useLingui();

  const {
    subLocations: { subLocations, setSubLocations },
  } = useFilters();

  const subLocationOptions = useSubLocationOptions();

  const subLocationIds = subLocations.map((subLocation) => subLocation.id);

  const toggleSubLocation = (optionId: string) => {
    const option = subLocationOptions.find(({ id }) => id === optionId);

    if (option) {
      if (subLocationIds.includes(optionId)) {
        setSubLocations(subLocations.filter(({ id }) => id !== optionId));
      } else {
        setSubLocations([...subLocations, option]);
      }
    }
  };

  const options =
    subLocationOptions.length > 0 ? (
      subLocationOptions.map(({ id, label }) => (
        <FilterCheckboxItem key={id} id={id} label={label} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="sub-location"
      icon={<IconTools />}
      label={t({ id: 'requests.filters.sub-location.label', message: 'Sub-location' })}
      count={subLocations.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.sub-location.label', message: 'Sub-location' })}
        values={subLocationIds}
        onChange={toggleSubLocation}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
